import PropTypes from 'prop-types';

/**
 * Call to Action Button
 * @param {{
 * type:"submit" | "button" | "reset",
 * children:string | JSX.Element,
 * variant: "main" | "secondary" | "danger",
 * disabled?:boolean | undefined,
 * title?: string | undefined,
 * onClick?:React.MouseEventHandler<HTMLButtonElement>
 * }} param0
 * @returns
 */
export default function ButtonCTASmall({ type, children, variant, ...props }) {
  const color = {
    main: 'bg-segments-accent-color-1 text-white hover:bg-segments-dark',
    secondary: ' bg-segments-gray hover:bg-segments-darker-gray',
    danger: ' bg-segments-danger text-white',
  };

  return (
    <button
      type={type}
      aria-label={String(children)}
      className={`block h-9 w-full text-base font-bold border focus:outline-none rounded-lg ${color[variant]} disabled:opacity-50 disabled:cursor-not-allowed`}
      {...props}
    >
      {children}
    </button>
  );
}

ButtonCTASmall.propTypes = {
  type: PropTypes.oneOf(['submit', 'button', 'reset']).isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
    .isRequired,
  variant: PropTypes.oneOf(['main', 'secondary', 'danger']).isRequired,
  disabled: PropTypes.bool,
};
